import { FC, useEffect, useRef } from 'react';
import { dispatch, useSelector } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';
import { markNotificationNoticeSeen } from 'store/reducers/notificationSettings';

// Aviso único de primeiro login sobre a política de notificação da instância (Etapa 4).
// Mostra uma vez pra todo mundo que ainda não viu — inclusive quem já usava o sistema antes
// dessa etapa existir, não só conta criada depois. Some assim que exibido, não reaparece.
const NotificationPolicyNotice: FC = () => {
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const shown = useRef(false);

  useEffect(() => {
    if (!isLoggedIn || !user || shown.current) return;
    if (user.notificationNoticeSeenAt) return;

    shown.current = true;
    dispatch(
      openSnackbar({
        open: true,
        message:
          'Suas notificações seguem o padrão definido pelo administrador. Você pode ajustar no seu perfil quando quiser.',
        variant: 'alert',
        alert: { color: 'info' },
        close: true,
        autoHideDuration: 8000
      })
    );
    dispatch(markNotificationNoticeSeen());
  }, [isLoggedIn, user]);

  return null;
};

export default NotificationPolicyNotice;
